import { useEffect, useState } from 'react'
import { api, periodenname, still } from './api'
import { t } from './sprache'

/**
 * Der Erfolgsmoment über der Arbeitsliste (7.7, R921, R922).
 *
 * Eine freundliche Zeile, wenn der Abschluss des Kreises freigegeben ist. Sie
 * **erscheint einmal** — die Anwendung merkt sich, wem sie welchen Moment
 * gezeigt hat — und **verschwindet mit dem nächsten Klick**. Sie verlangt
 * keinen: Kein Knopf, kein Fenster, nichts, was man wegräumen müsste (R921).
 *
 * **Ob sie erscheint, entscheidet die Anwendung und nicht die Oberfläche.**
 * Gefragt wird nur, wenn der Abschluss hier schon als freigegeben dasteht;
 * die Antwort prüft den Bestand noch einmal selbst, dazu den Schalter des
 * Anwenders und ob die Freigabe nach dem Einschalten lag (nichts wird
 * nachgeholt). Wer den Baustein aus hat, bekommt ein Nein und sieht nichts.
 */
export function Erfolgsmoment({
  kreis,
  kreisname,
  ledger,
  periode,
  abschlussstatus,
}: {
  kreis: string
  kreisname: string
  ledger: string
  periode: number
  /** Der Status des Abschlusses, wie die Freigabeprüfung ihn nennt. */
  abschlussstatus: string | null
}) {
  const [zeigen, setZeigen] = useState(false)
  const freigegeben = abschlussstatus === 'freigegeben'

  useEffect(() => {
    setZeigen(false)

    if (!freigegeben) {
      return
    }

    let gilt = true

    api
      .erfolgsmoment({ anlass: 'freigabe', kreis, ledger, periode })
      .then((antwort) => gilt && setZeigen(antwort.zeigen))
      // Ein Erfolgsmoment, der nicht kommt, ist kein Fehler, den jemand
      // erledigen müsste — er bleibt einfach aus, still (7.2 Abschnitt 30,
      // R1007). Ohne zweiten Versuch: Ein Glückwunsch drei Sekunden später
      // käme zur Unzeit.
      .catch((f) => {
        still(f)
      })

    return () => {
      gilt = false
    }
  }, [freigegeben, kreis, ledger, periode])

  useEffect(() => {
    if (!zeigen) {
      return
    }

    const weg = () => setZeigen(false)
    document.addEventListener('click', weg, { once: true })

    return () => document.removeEventListener('click', weg)
  }, [zeigen])

  if (!zeigen) {
    return null
  }

  return (
    <p className="erfolgsmoment" role="status">
      {t('spiel.moment.freigabe', { periode: periodenname(periode), kreis: kreisname })}
    </p>
  )
}
